import { GroupDivision } from "../shared/enums/GroupDivision";
import { ExcellenceCenter } from "./ExcellenceCenter.model";
import { Industry } from "./Industry.model";
import { SupportCenter } from "./SupportCenter.model";
export class User {
    _id: String;
    type: String;
    name: String;
    username: String;
    password: String;
    active: boolean;
    keySigner: String;
    division: GroupDivision = 0;
    __v: Number;
    secondaryDivisions: GroupDivision[] = [];
    isDefaultSignerConsultant: boolean;
    isDefaultSignerCompany: boolean;
    excellenceCenters: ExcellenceCenter[];
    industries: Industry[];
    supportCenters: SupportCenter[];

    loadUserDataForGrid(r: any) {
        this._id = r._id ? r._id : '';
        this.name = r.name ? r.name : '';
        this.username = r.username ? r.username : '';
        this.type = r.type ? r.type : '';
        this.division = r.division ? r.division : '';
        this.active = r.active ? r.active : false;
        this.isDefaultSignerConsultant = r.isDefaultSignerConsultant ? r.isDefaultSignerConsultant : false;
        this.secondaryDivisions = r.secondaryDivisions && r.secondaryDivisions.length > 0 ? r.secondaryDivisions : [];
        this.excellenceCenters = r.excellenceCenters && r.excellenceCenters.length > 0 ? r.excellenceCenters : [];
        this.industries = r.industries && r.industries.length > 0 ? r.industries : [];
        this.supportCenters = r.supportCenters && r.supportCenters.length > 0 ? r.supportCenters : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/models/User.model.ts